import moment from 'moment';
import transform from '@/services/catalogue/filters/produitServerTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'gescom/Produit/';

export async function get(id, dateVisualisation) {
  const queryItems = {
    params: {
      Id: id,
    },
  };
  if (dateVisualisation) {
    queryItems.params.DateVisualisation = moment(dateVisualisation).format('YYYY-MM-DD');
  }
  const response = await HTTP.get(URL_BASE + 'GetAsync', queryItems);
  return response;
}

export async function getAll(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}
